export const USER_INFO = 'userInfo';
export const USER_INFORMATION = 'userInformation';
export const USERTYPE_ADMIN = 0;
export const USERTYPE_COMPANYUSER = 1;
export const CONTROL_MODE_INFORMATION="controlModeInformation";